import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { FrontendPortal } from "@vega-api/generated/types/frontendPortal";

import { useTaskState } from "./useTaskState";
import { useTaskStateV2 } from "./useTaskStateV2";

export type TasksState =
  | (ReturnType<typeof useTaskState> & { version: "v1" })
  | (ReturnType<typeof useTaskStateV2> & { version: "v2" });

type UseTasksStateProps = {
  portal?: FrontendPortal;
};

export function useTasksState({ portal }: UseTasksStateProps = {}): TasksState {
  const { featureFlag, isLoading: isFeatureFlagLoading } = useFeatureFlag();
  const isV2 = Boolean(featureFlag[FeatureFlag.LP_AUTH_LOGIN_TASK]);

  const supportsV1 = portal !== FrontendPortal.GP_PORTAL;

  const v1 = useTaskState({
    enabled: !isFeatureFlagLoading && !isV2 && supportsV1,
  });
  const v2 = useTaskStateV2({ enabled: !isFeatureFlagLoading && isV2 });

  if (isV2) {
    return { version: "v2", ...v2 };
  }

  return { version: "v1", ...v1 };
}
